
        var result = require("!!../../../../../node_modules/css-loader/index.js!./customer-merge.css");

        if (result && result.__esModule) {
            result = result.default;
        }

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/views/admin/customer/customer-merge.css
// module id = 1477
// module chunks = 0